import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContactsComponent } from './contacts.component';
import { ContactsShowComponent } from './contacts-show/contacts-show.component';

const routes: Routes = [
  {
    path: 'contacts',
    children: [
      {
        path: '',
        component: ContactsComponent,
      },
      {
        path: ':id',
        component: ContactsShowComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ContactsRoutingModule {}
